import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './ProviderCreateScreen';
import ProviderCreate from './ProviderCreateScreen';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getServiceTypes } from 'src/store/actions/service-type-actions';
import { getServiceLocations } from 'src/store/actions/service-location-actions';
import { getProviders } from 'src/store/actions/provider-actions';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        serviceTypes: state.serviceTypes.data,
        inProgress: state.providers.inProgress,
        providers: state.providers.data,
        serviceLocations: state.serviceLocations.data,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getServiceTypes: (params: QueryParams) => dispatch(getServiceTypes(params)),
        getServiceLocations: (params: QueryParams) => dispatch(getServiceLocations(params)),
        getProviders: (params: QueryParams) => dispatch(getProviders(params)),
    };
}

const ProviderCreateScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(ProviderCreate);

export default ProviderCreateScreen;
